/** Placeholder palette. One accent per character so the three levels read as
 *  distinct even with zero real art. Swap freely during the art phase. */
export const Palette = {
  bg: 0x0e0f13,
  panel: 0x1a1d24,
  panelEdge: 0x2c313c,
  text: "#e6e6e6",
  textDim: "#9aa0ac",

  dan: 0x4fa3ff, // blue
  lucas: 0xffb020, // amber
  andrew: 0x46d17f, // green
  kirby: 0xff6ec7, // pink

  money: 0x2ec76b,
  laptop: 0x8fb3ff,
  vw: 0xcccccc,
  document: 0xe8d48b,
  feature: 0xb98bff,

  projectile: 0xffffff,
  box: 0xb5834f,
  key: 0xf2d34a,
  door: 0x9a5bd0,
  doorOpen: 0x3a2450,
  switchOff: 0xcc5555,
  switchOn: 0x55cc77,
  bug: 0xd14b4b,
  sheepy: 0xffffff, // drawn as a rainbow in code
  exit: 0xbc60c8,
  hazard: 0xce4848,
} as const;

/** Per-character accent used by level-select tiles + HUD tints. */
export const LevelAccent: Record<string, number> = {
  dan: Palette.dan,
  lucas: Palette.lucas,
  andrew: Palette.andrew,
};
